var map = {
	"./box-open.svg": "b7ff",
	"./comment.svg": "85d4",
	"./eye.svg": "4bfd",
	"./hand-paper.svg": "0573",
	"./hand-pointer.svg": "90fb",
	"./times-circle.svg": "5f27",
	"./twitter-square.svg": "2079",
	"./volume-mute.svg": "afab",
	"./volume-up.svg": "ca20",
	"./walking.svg": "9055",
	"./window-close.svg": "b865"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f655";